import { render } from "./DeliveryTime.vue?vue&type=template&id=5b569058"
import script from "./DeliveryTime.vue?vue&type=script&lang=js"
export * from "./DeliveryTime.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__